var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisibilityIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.77019C9.35196 7.77019 11.4774 6.49964 12.6154 4.5C11.4774 2.50036 9.35196 1.22981 7 1.22981C4.64804 1.22981 2.52261 2.50036 1.38456 4.5C2.52261 6.49964 4.64804 7.77019 7 7.77019ZM0.141083 4.22155C1.44234 1.65319 4.07426 0 7 0C9.92576 0 12.5576 1.65321 13.8589 4.22155L14 4.5L13.8589 4.77845C12.5577 7.34681 9.92574 9 7 9C4.07424 9 1.44235 7.3468 0.141083 4.77845L0 4.5L0.141083 4.22155ZM7.00697 6.72205C5.78277 6.72205 4.79035 5.7272 4.79035 4.5C4.79035 3.2728 5.78277 2.27795 7.00697 2.27795C8.23117 2.27795 9.22359 3.2728 9.22359 4.5C9.22359 5.7272 8.23117 6.72205 7.00697 6.72205ZM7.00697 5.49224C7.55362 5.49224 7.99678 5.04799 7.99678 4.5C7.99678 3.95201 7.55362 3.50776 7.00697 3.50776C6.46032 3.50776 6.01716 3.95201 6.01716 4.5C6.01716 5.04799 6.46032 5.49224 7.00697 5.49224Z",
    fill: "#0f9bb0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityIconBlue);
export default __webpack_public_path__ + "static/media/visibilityIconBlue.541b940af92a27c283cdffecc3438e5d.svg";
export { ForwardRef as ReactComponent };